import {
  HStack,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  VStack,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import Container from "../components/Container";
import Nav from "../components/nav/Nav";
import { Course } from "../const/types";
import ComponentSpinner from "../components/spinner/ComponentSpinner";
import CourseCard from "../components/card/CourseCard";
import cr from "../lib/request";
import { MagnifyingGlass } from "@phosphor-icons/react";
import Footer from "../components/Footer";
import NoData from "../components/feedback/NoData";
import TemaDropdown from "../components/TemaDropdown";
import useTemaAllCourses from "../globalState/useTemaAllCourses";
import useSearchAllCourses from "../globalState/useSearchAllCourses";
import { Cookies } from "typescript-cookie";
import useTrigger from "../globalState/useTrigger";

export default function AllCourses() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [data, setData] = useState<Course[] | null>(null);
  const { search, setSearch } = useSearchAllCourses();

  const ok = data?.filter(
    (course) =>
      course.nama_course.toLowerCase().includes(search.toLowerCase()) ||
      course.description.toLowerCase().includes(search.toLowerCase())
  );
  const [loading, setLoading] = useState<boolean>(false);
  const { tema } = useTemaAllCourses();
  const { trigger } = useTrigger();

  const getCourse = useCallback(() => {
    setLoading(true);
    const userCookie = Cookies.get("user") as string;
    let url;
    if (userCookie) {
      url = `api/usercourse/courseauth`;
    } else {
      url = `api/usercourse/course`;
    }
    const payload = {
      limit: null,
      offset: null,
      tema: tema?.id,
    };
    cr.post(url, payload)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [tema?.id]);

  useEffect(() => {
    getCourse();
  }, [getCourse, tema, trigger]);

  return (
    <VStack align={"stretch"} gap={0} minH={"100vh"}>
      <Nav />

      <Container mx={"auto"} py={12} minH={"calc(100vh - 72px)"}>
        <Heading fontSize={28} mx={"auto"} textAlign={"center"} mb={8}>
          Temukan Online Course Favoritmu
        </Heading>

        <HStack mb={8} mx={"auto"}>
          <InputGroup>
            <InputLeftElement>
              <Icon as={MagnifyingGlass} />
            </InputLeftElement>
            <Input
              w={"100%"}
              maxW={"500px"}
              placeholder="Cari course"
              _placeholder={{ opacity: 0.8 }}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />
          </InputGroup>

          <TemaDropdown />
        </HStack>

        <VStack mt={4}>
          {!loading && data ? (
            ok && ok?.length > 0 ? (
              <SimpleGrid columns={[1, 2, 3, 4]} gap={4} spacingY={8}>
                {ok.map((course, i) => {
                  return <CourseCard key={i} data={course} />;
                })}
              </SimpleGrid>
            ) : (
              <NoData />
            )
          ) : (
            <ComponentSpinner />
          )}
        </VStack>
      </Container>

      <Footer />
    </VStack>
  );
}
